import React, { useState, useEffect } from "react";
// import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import { MaterialReactTable } from "material-react-table";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { MenuItem } from "@mui/material";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
} from "../../../../common/Constant";
import { Box, Button } from "@mui/material";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import { checkUserPermission } from "../../../../common/UserPermission";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/modifiers-manage";
let PERMISSION_EDIT = "/modifiers-manage/:id";
let PERMISSION_DELETE = "delete-modifiers";

let selectData = [];
const Modifiers = () => {
  const loginUserId = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [sortingId, setSortingId] = useState(4);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);

  ///----------server side-------
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [filtertext, setFiltertext] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const navigate = useNavigate();

  const handleDeletePopup = (pID) => {
    // console.log(pID);
    const deleteRequestParam = {
      id: pID,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);
    const FilterColumnText = {};

    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = ((sorting.length > 0) ? sorting[0]?.id : "") 

    axios
      .get(
        `${
          config.modifiersBaseUrl
        }/modifiers?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log(res.data.ResponseData[0].TotalRecord);
        setData(res.data.ResponseData);
        setLoading(false);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    // console.log(values, row, "handleSaveRow");
    //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    data[row.index] = values;
    // //send/receive api updates here
    setData([...data]);

    let modifiersitems = {};
    modifiersitems.data = values;
    let modifiersitemsxml = JSON.stringify(modifiersitems);

    axios
      .post(
        `${config.manufacturerBaseUrl}/modifiers/upsert`,
        {
          id: row.original.ID,
          name: values.Name,
          loginuserid: loginUserId,
          modifiersitemsxml: modifiersitemsxml,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          // handleListData();
          setLoading(false);
          // window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });

    exitEditingMode(); //required to exit editing mode
  };

  useEffect(() => {
    handleListData(
      1,
      perPage,
      filtertext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [
    filtertext,
    sortingId,
    sortingDirection,
    pagination,
    columnFilters,
    globalFilter,
    sorting,
  ]);

  const columns = [
    // {
    //   name: "ID",
    //   selector: "ID",
    //   sortable: true,
    // },
    // {
    //   name: "Name",
    //   selector: "Name",
    //   sortable: true,
    // },
    // {
    //   name: "Values",
    //   selector: "Value",
    //   sortable: true,
    // },
    // {
    //   name: "Created On",
    //   selector: (row) => formatDate(row.CreatedDate),
    //   sortable: true,
    // },
    // {
    //   name: "Action",
    //   width: "20%",
    //   cell: (row) => (
    //     <>
    //       {checkUserPermission(PERMISSION_EDIT) ? (
    //         <Link className="me-3" to={`/modifiers-manage/${row.ID}`}>
    //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
    //         </Link>
    //       ) : (
    //         ""
    //       )}
    //       {checkUserPermission(PERMISSION_DELETE) ? (
    //         <Link
    //           className="confirm-text"
    //           to="#"
    //           title="Delete"
    //           data-bs-toggle="modal"
    //           data-bs-target="#DeleteConfirmationModal"
    //           onClick={() => handleDeletePopup(row.ID)}
    //         >
    //           <i
    //             className="fa fa-trash text-red fa-2x"
    //             data-bs-toggle="tooltip"
    //             title="Delete"
    //           ></i>
    //         </Link>
    //       ) : (
    //         ""
    //       )}
    //     </>
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    // },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Values",
      accessorKey: "Value",
    },
    {
      header: "Created On",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("YYYY-DD-MM HH:mm:ss"),
    },
  ];

  const handleSelectedRowsChange = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedData(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
    }
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPage, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPage, searchtext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPage, e.target.value, sortingId, sortingDirection);
    // console.log(handleListData);
  };

  // const rowSelectCritera = row => row.fat > 6;

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Items: Modifiers</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Modifiers</li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-4">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
            <div>
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="/modifiers-manage"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  Add Modifiers
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          {/* /Page Header */}
          {/* <div className="row">
            <div className="row flex-row-reverse">
              <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm w-50 pull-right"
                  onChange={ChangeFilterText}
                  value={searchtext}
                />
              </div>
            </div>
          </div> */}

          <div className="row">
            <div className="col-sm-12">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="table-responsive">
                    {/* <DataTable
                      columns={columns}
                      data={data}
                      progressPending={loading}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={(e) => {
                        handlePerRowsChange(1, e);
                      }}
                      onChangePage={handlePageChange}
                      highlightOnHover
                      striped
                      responsive
                      paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                      persistTableHead
                      sortServer
                      onSort={handleSort}
                      onSelectedRowsChange={(e) => {
                        handleSelectedRowsChange(e);
                      }}
                    /> */}
                    <MaterialReactTable
                      columns={columns}
                      //  title="Deleted Customer List"
                      data={data}
                      // positionPagination='top'
                      enableColumnResizing
                      enableGrouping
                      enableStickyHeader
                      enableStickyFooter
                      // enableRowSelection
                      enableColumnOrdering
                      enableRowActions={ checkUserPermission(PERMISSION_EDIT) ||  checkUserPermission(PERMISSION_DELETE)}
                      positionGlobalFilter="left"


                      // editDisplayMode="row"
                      // enableEditing
                      // onEditingRowSave={handleSaveRow}
                      renderRowActionMenuItems={({ row, table }) => [
                        checkUserPermission(PERMISSION_EDIT) ? (
                          <MenuItem
                            key="edit"
                            data-bs-toggle="modal"
                            data-bs-target="#ManageDataModal"
                            onClick={() =>
                              navigate(`/modifiers-manage/${row.original.ID}`)
                            }
                          >
                            {/* <EditIcon /> */}
                            Edit
                          </MenuItem>
                        ) : (
                          ""
                        ),
                        checkUserPermission(PERMISSION_DELETE) ? (
                          <MenuItem
                            className="confirm-text"
                            to="#"
                            key="delete"
                            // title="Delete"
                            // data-bs-toggle="modal"
                            // data-bs-target="#DeleteConfirmationModal"
                            // onClick={() => handleDeletePopup(row.original.Id)}
                            // data-bs-toggle="modal"
                            // data-bs-target="#DeleteConfirmationModal"
                            onClick={() => handleDeletePopup(row.original.ID)}
                          >
                            {/* <DeleteIcon /> */}
                            Delete
                          </MenuItem>
                        ) : (
                          ""
                        ),
                      ]}
                      renderTopToolbarCustomActions={({ table }) => (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "1rem",
                            p: "0.5rem",
                            flexWrap: "wrap",
                          }}
                        >
                          {/* <Button
                            size="small"
                            onClick={() =>
                              // setPagination({ ...pagination, pageSize: totalRows })
                              setPagination({
                                ...pagination,
                                pageIndex: 0,
                                pageSize: totalRows,
                              })
                            }
                            variant="contained"
                          >
                            Get All Data
                          </Button> */}
                        </Box>
                      )}
                      // rowVirtualizerOptions={{
                      //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                      //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                      // }}

                      muiTableContainerProps={{
                        sx: { maxHeight: "fit-content" },
                      }}
                      initialState={{
                        density: "comfortable",
                        showGlobalFilter: true ,
                        expanded: true, //expand all groups by default
                        // grouping: [""], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 50 },
                        // sorting: { id: "Name", desc: false }, //sort by state by default
                      }}
                      //For color of each alternative row(Zebra-column)
                      muiTableBodyProps={{
                        sx: () => ({
                          "& tr:nth-of-type(even)": {
                            backgroundColor:
                              "var(--datatable-row-background-color)",
                            //'rgb(237 237 233 / 63%)'
                          },
                          "& td": {
                            borderRight:
                              "1px solid var(--datatable-row-background-hover-color)",
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },

                          "& tr": {
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },
                        }),
                      }}
                      muiPaginationProps={{
                        rowsPerPageOptions: [10, 25, 50, 100, 300],
                      }}
                      manualPagination
                      manualSorting
                      muiToolbarAlertBannerProps={
                        // isError
                        // ? {
                        //   color: "error",
                        //   children: "Error loading data",
                        // }
                        // : undefined
                        {
                          isError: () => ({
                            color: "error",
                            children: "Error loading data",
                          }),
                          sx: (theme) => ({
                            background: "var(--datatable-row-background-color)", //'#e9e9e9',
                            lineHeight: "16px",
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          }),
                        }
                      }
                      muiSelectCheckboxProps={{
                        sx: (theme) => ({
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--prinary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      muiSelectAllCheckboxProps={{
                        sx: (theme) => ({
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--prinary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      muiTableHeadCellProps={{
                        sx: (theme) => ({
                          background: "var(--datatable-row-background-color)", //'#e9e9e9',
                          borderRight:
                            "1px solid var(--datatable-row-background-hover-color)",
                          lineHeight: "16px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                      onGlobalFilterChange={setGlobalFilter}
                      onPaginationChange={setPagination}
                      onSortingChange={setSorting}
                      rowCount={totalRows}
                      // enableColumnVirtualization={false}

                      // enableColumnVirtualization

                      state={{
                        // columnFilters, // for termp comment filteron column
                        globalFilter,
                        filtertext,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.modifiersBaseUrl}/modifiers/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default Modifiers;
